// extracted by mini-css-extract-plugin
export default {"disabledLink":"TopNavigationBar_disabledLink__5NN6h"};